import React from 'react';
import { connect } from 'react-redux';
import { List, Card, Tag, Modal, Button, Row } from 'antd';
import { createStructuredSelector } from 'reselect';
import moment from 'moment';
import axios from 'axios';

import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';
import { tableTranslation } from '../../../Utils/Adapter/translationAdapter';
import ReactEcharts from '../../Echarts/Echarts';
import { getTranslationCache } from '../../../../../selectors/language';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import localStorage from '../../../../../utils/localStorage';
import { getCurrentTimezone } from '../../../../../selectors/layout';
import { arrayOfObjects } from '../../../Mock/MockJson';
import { defaultRefreshTime } from '../../constant.json';
import '../../CSS/CounterList.css';
import { API_TRENDS } from '../../../../../commons/api';

class CardsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cardsList: [],
      translationCache: props.translationCache || [],
      refreshDateTime: moment(),
      errorInAPI: false,
      noDataInDB: false,
      last30Records: false,
      option: this.getOption()
    };
  }

  timeTicket = null;
  requestCheck = true;
  abortController = new window.AbortController();

  async componentDidMount() {
    let { graphprops } = this.props;
    if (this.timeTicket) {
      clearInterval(this.timeTicket);
    }
    this.getData(this.props);
    if (
      graphprops &&
      graphprops[graphprops.graph] &&
      graphprops[graphprops.graph].show30minsData &&
      graphprops[graphprops.graph].show30minsData === 'true'
    ) {
      this.getLast30minsData();
    }

    let refreshTime = '';
    if (this.props.graphprops.refreshTime) {
      refreshTime = this.props.graphprops.refreshTime * 60000;
    } else {
      refreshTime = defaultRefreshTime;
    }

    this.timeTicket = setInterval(() => {
      if (this.requestCheck) {
        this.getData(this.props, this.props.selectedThemeing);
      }
    }, refreshTime);
  }

  componentWillUnmount() {
    this.abortController.abort();
    clearInterval(this.timeTicket);
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.graphprops !== this.props.graphprops ||
      prevProps.selectionDate !== this.props.selectionDate ||
      prevProps.selectionDateLive !== this.props.selectionDateLive ||
      prevProps.selectionMonth !== this.props.selectionMonth ||
      prevProps.selectionWeek !== this.props.selectionWeek ||
      prevProps.DeviceCode !== this.props.DeviceCode ||
      prevProps.shift !== this.props.shift ||
      prevProps.selectionDateRange !== this.props.selectionDateRange ||
      prevProps.dayMonthYear !== this.props.dayMonthYear ||
      prevProps.dropdownSelection !== this.props.dropdownSelection ||
      prevProps.dashboardPayload !== this.props.dashboardPayload ||
      prevProps.AssetCode !== this.props.AssetCode ||
      prevProps.translationCache !== this.props.translationCache
    ) {
      this.getData(this.props);
    }
  }

  getLast30minsData = () => {
    let payload = {
      Type: 'live',
      ViewType: 'Single',
      GraphType: 'line',
      ParameterList: [
        {
          ParameterCode: 'Brake_Status_Motoring',
          DeviceCode: 'BECU_12',
          TableName: 'OnChange',
          parameterType: 'OnChange',
          parameterDescription: '-',
          parameterName: 'Drive Speed Command',
          deviceName: 'Brake_Electronic_Control_Unit'
        },
        {
          ParameterCode: 'Brake_Status_Motoring',
          DeviceCode: 'BECU_19',
          TableName: 'OnChange',
          parameterType: 'OnChange',
          parameterDescription: '-',
          parameterName: 'Drive Output Voltage',
          deviceName: 'Brake_Electronic_Control_Unit'
        },
        {
          ParameterCode: 'Brake_Status_Coasting',
          DeviceCode: 'BECU_1',
          TableName: 'OnChange',
          parameterType: 'OnChange',
          parameterDescription: '-',
          parameterName: 'Motor Speed Status',
          deviceName: 'Brake_Electronic_Control_Unit'
        }
      ],
      SiteId: '1'
    };
    const accessToken = localStorage.get('accessToken');
    const SiteId = localStorage.get('currentSite');
    const deviceTypeObject = {
      method: 'POST',
      url: `${API_TRENDS.LIST}?SiteId=${SiteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      },
      json: payload
    };
    axios(deviceTypeObject)
      .then((response) => {
        let { option } = this.state;
        let json = response.data;
        let legendData = json.map((item) => item.Description);
        let xAxisData = json.map((item) => item.DateTime);
        let seriesData =
          legendData &&
          Array.isArray(legendData) &&
          legendData.map((legend) => {
            let dataObject =
              json &&
              Array.isArray(json) &&
              json.map((e) => {
                if (e.Description === legend) {
                  return e.Value;
                }
                return {};
              });
            return {
              name: legend,
              type: 'line',
              stack: 'Total',
              json: dataObject
            };
          });

        option = {
          ...option,
          legend: {
            json: legendData
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            json: xAxisData
          },
          series: seriesData
        };
        this.setState({ option });
      })
      .catch(function () {});
  };

  getData = async () => {
    this.requestCheck = false;
    let { graphprops } = this.props;
    let json = [];
    let { errorInAPI, noDataInDB } = this.state;
    errorInAPI = false;
    noDataInDB = false;
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = arrayOfObjects;
      this.requestCheck = true;
    } else {
      if (
        (graphprops &&
          (graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
          this.props.selectionDate) ||
        (graphprops &&
          (graphprops.DashboardLevelSelection === 'monthPicker' ||
            graphprops.GraphLevelSelection === 'monthPicker') &&
          this.props.selectionMonth) ||
        (graphprops &&
          (graphprops.DashboardLevelSelection === 'weakPicker' ||
            graphprops.GraphLevelSelection === 'weakPicker') &&
          this.props.selectionWeek) ||
        (graphprops &&
          (graphprops.DashboardLevelSelection === 'shiftPicker' ||
            graphprops.GraphLevelSelection === 'shiftPicker') &&
          this.props.shift) ||
        (graphprops &&
          (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
            graphprops.GraphLevelSelection === 'dateRangePicker') &&
          this.props.selectionDateRange) ||
        (graphprops &&
          (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
            graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
          this.props.dayMonthYear) ||
        (graphprops && graphprops.dashboardType === 'dynamic') ||
        (graphprops.dashboardType === 'dropdownHide' && this.props.DeviceCode) ||
        (graphprops && graphprops.dashboardType === 'hierarchy' && this.props.dropdownSelection) ||
        (graphprops && this.props.dashboardPayload) ||
        (graphprops && graphprops.treeExists === 'true' && this.props.AssetCode)
      ) {
        json = await getChartDataWithSelection({
          graphprops,
          DeviceCode: this.props.DeviceCode,
          selectionDate: this.props.selectionDate,
          selectionMonth: this.props.selectionMonth,
          selectionWeek: this.props.selectionWeek,
          shift: this.props.shift,
          selectionDateRange: this.props.selectionDateRange,
          dayMonthYear: this.props.dayMonthYear,
          abortController: this.abortController,
          dropdownSelection: this.props.dropdownSelection,
          dashboardPayload: this.props.dashboardPayload,
          AssetCode: this.props.AssetCode,
          selectionDateLive: this.props.selectionDateLive,
          currentTimeZone: this.props.currentTimeZone
        });
        this.requestCheck = true;
      } else {
        json = await getChartDataWithoutSelection({
          graphprops,
          abortController: this.abortController,
          dropdownSelection: this.props.dropdownSelection,
          DeviceCode: this.props.DeviceCode,
          TimeZone: this.props.currentTimeZone
        });
        this.requestCheck = true;
      }
    }
    if (
      (json && json.message) ||
      (Array.isArray(json) && json.length === 0 && graphprops.enableMock !== true)
    ) {
      if (json.message) {
        errorInAPI = true;
      } else if (json.length === 0) {
        noDataInDB = true;
      }
    } else {
      if (json && Array.isArray(json) && json.length > 0) {
        let columnsData = await tableTranslation(json, this.props.translationCache);
        let cardsList = columnsData.map((column) => {
          return {
            title: column.Description,
            value: column.Value
          };
        });
        this.setState({ cardsList });
      } else {
        this.setState({
          cardsList: [],
          refreshDateTime: moment()
        });
      }
    }
    this.setState({
      errorInAPI,
      noDataInDB
    });
  };

  getOption = () => {
    let theme = this.props.selectedThemeing;
    let option = {
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        json: []
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      toolbox: {
        showTitle: false,
        itemSize: 25,
        feature: {
          saveAsImage: {
            backgroundColor: theme === 'lightTheme' ? 'black' : 'white',
            title: 'download',
            name: this.props.graphprops.title,
            iconStyle: {
              borderColor: '#8c8c8c',
              borderWidth: 2
            }
          }
        }
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        json: []
      },
      yAxis: {
        type: 'value'
      },
      series: []
    };
    return option;
  };

  render() {
    const { errorInAPI, noDataInDB, refreshDateTime, last30Records, option, cardsList } =
      this.state;
    let { graphprops } = this.props;
    let colors = [
      // 'steelblue',
      // '#a0d911',
      // '#faad14',
      // '#c41d7f',
      // '#006d75',
      // 'steelblue',
      // '#a0d911',
      // '#faad14',
      // '#c41d7f',
      // '#006d75'
    ];
    if (
      graphprops &&
      graphprops[graphprops.graph] &&
      graphprops[graphprops.graph].colors &&
      graphprops[graphprops.graph].colors.length > 0
    ) {
      colors = {
        ...(graphprops[graphprops.graph].colors &&
        Array.isArray(graphprops[graphprops.graph].colors)
          ? graphprops[graphprops.graph].colors
          : []),
        ...colors
      };
    }
    return (
      <>
        {graphprops && graphprops.checked === true ? (
          <Tag className="graphTag" color="blue">
            {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
          </Tag>
        ) : null}
        {last30Records ? (
          <Modal
            title="Last 30mins Data"
            open={last30Records}
            onCancel={() => {
              this.setState({ last30Records: false });
            }}
          >
            <ReactEcharts
              option={option}
              notMerge={true}
              lazyUpdate={true}
              className="react_for_echarts"
            />
          </Modal>
        ) : null}
        {graphprops &&
        graphprops[graphprops.graph] &&
        graphprops[graphprops.graph].show30minsData &&
        graphprops[graphprops.graph].show30minsData === 'true' ? (
          <Button
            type="primary"
            style={{ float: 'right' }}
            onClick={() => {
              this.setState({ last30Records: true });
            }}
          >
            Show last 30mins Data
          </Button>
        ) : null}
        {noDataInDB === true || errorInAPI === true ? (
          noDataInDB === true ? (
            <NoRecordComponent />
          ) : (
            <ErrorComponent />
          )
        ) : (
          <div style={{ padding: '10px' }}>
            {this.props &&
            this.props.graphprops &&
            this.props.graphprops[graphprops.graph] &&
            this.props.graphprops[graphprops.graph].viewType === 'listOfItems' ? (
              <List
                itemLayout="horizontal"
                dataSource={cardsList}
                renderItem={(item, index) => (
                  <List.Item>
                    <List.Item.Meta
                      style={{ marginLeft: '30px' }}
                      title={
                        <span style={{ color: colors[index], fontSize: '16px' }}>{item.title}</span>
                      }
                    />
                    <Row>
                      <div style={{ color: colors[index], fontSize: '16px' }}>{item.value}</div>
                    </Row>
                  </List.Item>
                )}
              />
            ) : null}

            {this.props &&
            this.props.graphprops &&
            this.props.graphprops[graphprops.graph] &&
            this.props.graphprops[graphprops.graph].viewType === 'listOfCards' ? (
              <List
                grid={{
                  gutter: 10,
                  column: this.props.graphprops[graphprops.graph].numberOfColumns
                    ? this.props.graphprops[graphprops.graph].numberOfColumns
                    : 3
                }}
                dataSource={cardsList}
                style={{
                  textAlign: 'center',
                  textColor: '#fff !important',
                  fontSize: '3.5em'
                }}
                renderItem={(item, index) => (
                  <List.Item>
                    <Card
                      className="counterCard"
                      title={item.title}
                      style={{ backgroundColor: colors[index] || 'black', fontSize: '1.5em' }}
                    >
                      {graphprops &&
                      graphprops[graphprops.graph] &&
                      graphprops[graphprops.graph].displayType &&
                      graphprops[graphprops.graph].displayType === 'Image' ? (
                        <img
                          src={item.value}
                          type="image"
                          alt=""
                          style={{ marginTop: '8px', height: '222px' }}
                        />
                      ) : (
                        item.value
                      )}
                    </Card>
                  </List.Item>
                )}
              />
            ) : null}
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  translationCache: getTranslationCache(),
  currentTimeZone: getCurrentTimezone()
});

export default connect(mapStateToProps)(CardsList);
